module.exports = vendors_en_bde2f2e6a941e8a7bd36;